export default __webpack_public_path__ + "static/media/gastos.160a2ba8.png";